import ExcelJS from 'exceljs';

const downloadExcelData = async (data,setIsLoading2,label,selectedRowIds ) => {
    setIsLoading2(true);
    // console.log('setIsLoading3', isLoading2);
    const filteredData = data.filter(item => selectedRowIds.includes(item.id));

    if (filteredData.length === 0) {
        alert('No rows selected for export Excel!');
        return;
    }

    const desiredColumnOrder = Object.keys(filteredData[0]);

    const headerMapping = {
        id: 'Serial No',
        Image: '', // This will represent the "Image" column
        ProductId: `${label[0].attributes.AliasCode}`,
        Description: `${label[0].attributes.Description}`,
        ProductName: `${label[0].attributes.ProductName}`,
        SizeUnit: `${label[0].attributes.Sizeunit}`,
        FinishName: `${label[0].attributes.finish}`,
        ColorName: `${label[0].attributes.color}`,
        CategoryName: `${label[0].attributes.Category}`,
        SellingPrice: `${label[0].attributes.SalePrice}`,
        BuyerSku: `${label[0].attributes.BuyerSku}`,
        BuyerName: `${label[0].attributes.BuyerName}`,
        HSNCode: `${label[0].attributes.HSN}`,
        GrossWeight: `${label[0].attributes.GrossWgt}`,
        NetWeight: `${label[0].attributes.NetWgt}`,
        ProductTypeName: `${label[0].attributes.ProductType}`,
        MOQ: `${label[0].attributes.MOQ}`,
        cbm: 'CBM'
    };

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Add header row
    const headerRow = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerRow);

    // Style header row
    const header = worksheet.getRow(1);
    header.height = 30;
    header.eachCell(cell => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'cccaca' } };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
    });

    worksheet.getColumn(1).width = 10; // Set first column width

    let serialNumber = 1;

    for (const item of filteredData) {
        const rowValues = desiredColumnOrder.map(key => {
            if (key === 'id') {
                return serialNumber++; // Replace 'id' with serial number
            } else if (key === 'Image') {
                return ''; // Leave the Image column empty for now
            } else {
                return item[key] || '';
            }
        });

        const row = worksheet.addRow(rowValues);

        // Fetch and embed image
        const imageUrl = `${item.Image}`;
        if (imageUrl) {
            try {
                const imageResponse = await fetch(imageUrl);
                if (imageResponse.ok) {
                    const imageBuffer = await imageResponse.arrayBuffer();

                    // Create an image element to fetch its natural dimensions
                    const img = new Image();
                    img.src = URL.createObjectURL(new Blob([imageBuffer]));

                    // Wait for the image to load to get its dimensions
                    await new Promise((resolve, reject) => {
                        img.onload = () => {
                            const aspectRatio = img.width / img.height;
                            const maxWidth = 80; // Max width for the cell
                            const maxHeight = 80; // Max height for the cell
                            let width = maxWidth;
                            let height = maxHeight;

                            // Scale image while maintaining aspect ratio
                            if (img.width > img.height) {
                                height = width / aspectRatio;
                            } else {
                                width = height * aspectRatio;
                            }

                            const imageId = workbook.addImage({
                                buffer: imageBuffer,
                                extension: 'png'
                            });

                            worksheet.addImage(imageId, {
                                tl: { col: 1.3, row: row.number - 0.5 },
                                ext: { width, height }
                            });

                            row.height = 90; // Adjust row height
                            resolve();
                        };
                        img.onerror = reject;
                    });
                } else {
                    console.error(`Failed to fetch image for item ID: ${item.id}`);
                }
            } catch (error) {
                console.error(`Error fetching or embedding image for item ID: ${item.id}`, error);
            }
        }
    }

    // Adjust column widths
    worksheet.columns.forEach((column, index) => {
        if (index > 0) column.width = 20;
    });

    // Align and style all rows
    worksheet.eachRow(row => {
        row.eachCell(cell => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Save the Excel file
    const excelBuffer = await workbook.xlsx.writeBuffer();
    const excelData = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    setIsLoading2(false);
    // console.log('setIsLoading3', isLoading2);
    saveAs(excelData, 'selected_rows_export.xlsx');
};

const downloadExcelDataa = async data => {
    const filteredData = data.filter(item => selectedRowIds.includes(item.id));

    if (filteredData.length === 0) {
      alert('No rows selected for export Excel!');
      return;
    }

    const desiredColumnOrder = Object.keys(filteredData[0]);

    const headerMapping = {
      id: 'Serial No',
      Image: '', // This will represent the "Image" column
      ProductId: `${label[0].attributes.AliasCode}`,
      Description: `${label[0].attributes.Description}`,
      ProductName: `${label[0].attributes.ProductName}`,
      SizeUnit: `${label[0].attributes.Sizeunit}`,
      FinishName: `${label[0].attributes.finish}`,
      ColorName: `${label[0].attributes.color}`,
      Category: `${label[0].attributes.Category}`,
      [`Sale Price`]: `${label[0].attributes.SalePrice}`,
      [`Buyer Sku`]: `${label[0].attributes.BuyerSku}`,
      [`Buyer Name`]: `${label[0].attributes.BuyerName}`,
      [`HSN Code`]: `${label[0].attributes.HSN}`,
      [`Gross Weight`]: `${label[0].attributes.GrossWgt}`,
      [`Net Weight`]: `${label[0].attributes.NetWgt}`,
      [`Product Type`]: `${label[0].attributes.ProductType}`,
      [`MOQ`]: `${label[0].attributes.MOQ}`,
      cbm: 'CBM'
    };

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Add header row
    const headerRow = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerRow);

    // Style header row
    const header = worksheet.getRow(1);
    header.height = 30;
    header.eachCell(cell => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'cccaca' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Set first column width
    worksheet.getColumn(1).width = 10;

    // Populate data rows with serial numbers and placeholders for images
    let serialNumber = 1;
    for (const item of filteredData) {
      const rowValues = desiredColumnOrder.map(key => {
        if (key === 'id') {
          return serialNumber++; // Replace 'id' with serial number
        } else if (key === 'Image') {
          return ''; // Leave the Image column empty for now
        } else {
          return item[key] || '';
        }
      });

      const row = worksheet.addRow(rowValues);
      // row.height = 60;

      // Fetch image based on item id and embed it in the row
      const imageUrl = `${item.Image}`;
      if (imageUrl) {
        try {
          const imageResponse = await fetch(imageUrl);
          if (!imageResponse.ok) {
            console.error(`Failed to fetch image. HTTP status: ${imageResponse.status}`);
            return; // Skip image if not found
          }
          const imageBuffer = await imageResponse.arrayBuffer();
          const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: 'png' // Ensure the format matches the image type (can be 'jpg', 'png', etc.)
          });
          const img = new Image();
          img.src = URL.createObjectURL(new Blob([imageBuffer]));
          img.onload = () => {
            // Calculate the aspect ratio
            const aspectRatio = img.width / img.height;

            // Define the maximum dimensions for the image in the cell
            const maxWidth = 100; // Max width of the image (in pixels)
            const maxHeight = 100; // Max height of the image (in pixels)

            // Adjust the image size to fit within the defined max dimensions while maintaining aspect ratio
            let imgWidth = maxWidth;
            let imgHeight = Math.round(maxWidth / aspectRatio);

            if (imgHeight > maxHeight) {
              imgHeight = maxHeight;
              imgWidth = Math.round(maxHeight * aspectRatio);
            }

            worksheet.addImage(imageId, {
              tl: { col: 1.3, row: worksheet.rowCount - 1.5 },
              // Positioning the image
              //  tl: { col: 2, row: worksheet.rowCount },
              ext: { width: imgWidth, height: imgHeight }
            });
            row.height = 88; // Adjust row height for the embedded image
          };
        } catch (error) {
          console.error(`Failed to fetch or embed image for id ${item.id}`, error);
        }
      }
    }

    // Adjust remaining columns' width
    worksheet.columns.forEach((column, index) => {
      if (index > 0) column.width = 20; // First column is already set to 10
    });

    // Align and style all rows
    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // Save the Excel file
    const excelBuffer = await workbook.xlsx.writeBuffer();
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(excelData, 'selected_rows_export.xlsx');
  };
 

export {downloadExcelData};